import { render, staticRenderFns } from "./shebeiAuth.vue?vue&type=template&id=0873e2d0&scoped=true&"
import script from "./shebeiAuth.vue?vue&type=script&lang=js&"
export * from "./shebeiAuth.vue?vue&type=script&lang=js&"
import style0 from "./shebeiAuth.vue?vue&type=style&index=0&id=0873e2d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0873e2d0",
  null
  
)

export default component.exports